<template>
    <div>
        <!-- Gerar Lançamento de Devolução -->
        <div class="modal fade" id="devolPacienteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="lancamento">
                    <div class="modal-header">
                        <h5 class="modal-title">Devolução</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card" v-if="edicao_valor">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ marcacao: edicao_valor }" />
                                <hr>
                                <celula-dados-procedimento :hor="{ marcacao: edicao_valor.marcacao, total_items: edicao_valor.total_items }" :blockanexos="true" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    label="Emissão"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="lancamento.dt_emissao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    label="Vencimento"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="lancamento.dt_vencimento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    label="Documento"
                                    :validate="validate"
                                    v-model="lancamento.st_doc" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    label="Valor"
                                    type="money"
                                    required
                                    :validate="validate"
                                    v-model="lancamento.dc_valor" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Categoria"
                                    required
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="categorias.index"
                                    :optionsName="'categorias.D'"
                                    optionsData="id_categoria"
                                    optionsDisplay="search"
                                    :optionsParm="{ lancamento: true, where: { ch_natureza: 'D' } }"
                                    v-model="lancamento.id_categoria" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Centro de Custo"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="lista_centros"
                                    optionsData="id_centro_custo"
                                    :validate="validate"
                                    v-model="lancamento.id_centro_custo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Histórico"
                                    required
                                    :validate="validate"
                                    v-model="lancamento.st_descricao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="2"
                                    v-model="lancamento.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">{{ lancamento.id_lancamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-lancamento ref="lanc" @refresh="refresh()" />
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import EdicaoLancamento from '../financeiro/EdicaoLancamento.vue';

export default {
    data() {
        return { 
            lancamento: null, 
            validate: false, 
            edicao_valor: null, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento, 
        EdicaoLancamento, 
    }, 

    computed: { 
        lista_centros: function () { 
            
            if ( !this.lancamento || !this.lancamento.id_unidade_operacao ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.lancamento.id_unidade_operacao);

            return und ? und.centro_custos : [];

        },
    },

    methods: { 
        refresh () { 
            this.$emit('refresh');
        },

        editar (lanc) { 
            $('.modal').modal('hide');

            this.$refs.lanc.editar (lanc);
        },

        incluir(item) { 
            if ( !item || !item.reembolso ) { 
                alert('Item inválido.');
                return;
            }

            this.validate = false;
            this.edicao_valor = _.cloneDeep(item);

            $('.modal').modal('hide');

            this.lancamento = null;

            this.$nextTick(() => { 

                console.log(item);

                this.lancamento = { 
                    id_lancamento: null,
                    ch_tipo_lancamento: 'D', 
                    ch_estado: 'A',
                    recorrente: false, 
                    tipo_lanc: "", 
                    dt_competencia: this.$util.hoje().slice(0,7), 
                    dt_emissao: this.$util.hoje(),
                    dt_vencimento: this.$util.hoje(),
                    id_categoria: "",
                    st_observacoes: "", 
                    id_unidade_operacao: item.marcacao.id_unidade_operacao, 
                    id_centro_custo: "", 
                    categoria: "", 
                    dc_valor: 0, 
                    st_doc: "#" + item.reembolso.id_atendimento, 
                    id_reembolso: item.reembolso.id_reembolso, 
                    st_descricao: item.paciente.search, 
                };

                this.$refs.lanc.incluir (false, null, this.lancamento, "D");

                // $('#devolPacienteModal').modal('show');

            });
        },

        atualizar() { 

            this.lancamento.dt_competencia = this.lancamento.dt_emissao ? this.lancamento.dt_emissao.slice(0,7) : null;

            this.$util.atualizar(this, { 
                service: 'financeiro',
                func: 'store', 
                dados: this.lancamento, 
                modal: 'devolPacienteModal', 
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        }
    }
}
</script>
